import api from './axiosInstance';

export const getCropDiseasesApi = () => api.get('/crop-diseases');

export const addCropDiseaseApi = (formData, onUploadProgress) =>
  api.post('/crop-diseases', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress,
  });

export const updateCropDiseaseApi = (formData, onUploadProgress) =>
  api.post('/crop-diseases/update', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress,
  });

export const deleteImageApi = (data) =>
  api.post('/crop-diseases/delete-image', data);

export const deleteDiseaseApi = (data) =>
  api.post('/crop-diseases/delete', data);
